module.exports = __webpack_public_path__ + "img/kverneland_u_drill.47068230.jpg";